import React, { useRef, useState } from "react";

import { useMutationObserver } from "@react-hooks-library/core";

export const ClampedContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);

  const checkClamped = () => {
    if (!contentRef.current || isExpanded) return;
    setIsClamped(
      contentRef.current.scrollHeight > contentRef.current.clientHeight,
    );
  };

  const setContentRef = (node: HTMLDivElement | null) => {
    contentRef.current = node;
    checkClamped();
  };

  useMutationObserver(contentRef, checkClamped, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  return (
    <div className="relative flex flex-col">
      <div
        ref={setContentRef}
        className={isExpanded ? "decideScrollbar" : "line-clamp-5"}
        data-loc="clamped-content"
        data-record="true"
      >
        {children}
      </div>
      {isClamped &&
        (isExpanded ? (
          <button
            className="self-end font-inter-medium-13px text-gray-600 underline"
            onClick={() => setIsExpanded(false)}
          >
            See less
          </button>
        ) : (
          <span className="absolute right-0 bottom-0 flex items-center">
            <span className="h-5 w-12 bg-gradient-to-r from-transparent to-white" />
            <button
              className="bg-white pl-1 font-inter-medium-13px text-gray-600 underline"
              onClick={() => setIsExpanded(true)}
            >
              See more
            </button>
          </span>
        ))}
    </div>
  );
};
